import styled from 'styled-components';
import PropTypes from 'prop-types';
import { reduxPropTypes } from '@figure/frontlib-onboarding-redux';
import { Button, Error, Label, TitleTable } from '@figure/frontlib-gui';
import { useLeaveSurveyModal } from 'shared/hooks';
import { PageHeader } from 'shared/components/Typography';
import StaticDisclosureRows from './StaticDisclosureRows';
import { RightTableCell } from './RightTableCell';

const Container = styled.div`
  & th {
    font-size: 1.4rem;
  }
`;

const DisclosureReview = ({ disclosures, handleDownload, personalLoanUuid }) => {
  const { disableSurvey } = useLeaveSurveyModal();

  const handleBack = async () => {
    await disableSurvey();
    window.history.back();
  };

  return (
    <Container>
      <PageHeader>Download Disclosures</PageHeader>
      <TitleTable header="Important disclosures regarding your application">
        <tbody>
          <StaticDisclosureRows disclosures={disclosures} />
          {disclosures.map((d) => (
            <tr key={d.uuid}>
              <td>
                <Label>{d.document.description || d.document.type}</Label>
              </td>
              <RightTableCell>
                <Button secondary large onClick={() => handleDownload(d)}>
                  Download
                </Button>
              </RightTableCell>
            </tr>
          ))}
        </tbody>
      </TitleTable>

      <Error display="block">{disclosures.length ? '' : 'Could not retrieve disclosures'}</Error>

      <Button primary large center onClick={handleBack}>
        Back
      </Button>
    </Container>
  );
};

DisclosureReview.propTypes = {
  disclosures: PropTypes.arrayOf(reduxPropTypes.disclosure).isRequired,
  handleDownload: PropTypes.func.isRequired,
  personalLoanUuid: PropTypes.string.isRequired,
};

export default DisclosureReview;
